import { guestGuard, authGuard, requireWriteQc } from "./guards";

import { LoginView } from "@app/features/auth";
import {
  DataManagementView,
  FieldsView,
  WellsView,
  SamplesView,
  OilTestView,
  GasTestView,
  SampleInformationView,
  SampleValidationView,
} from "@app/features/data-management";
import {
  QaqcIndexView,
  QaqcOverviewView,
  QaqcDetailView,
} from "@app/features/qaqc";
import { StudioView } from "@app/features/studio";
import { AgenticDashboardView } from "@app/features/agentic";
import { FluidsIntelligenceView } from "@app/features/intelligence";
import {
  EdaDashboardView,
  DataInventoryAnalysisView,
  CompositionChartView,
  CorrelationAnalysisView,
  CorrelationCoefficientView,
  FluidsdataInsightView,
} from "@app/features/eda";
import { PvtPredictionView } from "@app/features/pvt";
import {
  DashboardMainView,
  DashboardBoardView,
  DashboardListView,
  DashboardViewView,
  DashboardCreateView,
  DashboardEditView,
} from "@app/features/dashboards";
import { UsersView, RolesView } from "@app/features/settings";
import {
  DifferentialLiberationView,
  ConstantCompositionExpansionView,
  MultiStageSeparatorTestView,
  OilViscosityView,
  CompositionView,
  CvdTestView,
} from "@app/features/tests";
import {
  AimlModellingView,
  DataInputsView,
  UploadReportsView,
  SelectDataView,
  DataPreviewView,
  AimlModelsView,
  SupervisedMlModelsView,
  FluidsdataAiModelView,
  BlackOilTableView,
  SelectedPvtReportView,
  FullPvtReportView,
  ManualDataEntryView,
} from "@app/features/aiml";

export const routes = [
  {
    path: "/",
    beforeEnter: guestGuard,
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    beforeEnter: guestGuard,
    component: LoginView,
    meta: { public: true },
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?/dltest/:id`,
    name: "DifferentialLiberationSection",
    beforeEnter: authGuard,
    component: DifferentialLiberationView,
  },
  {
    path: `/:tenantPrefix/Fluidsdata-studio`,
    name: "FluidsDataStudioTwo",
    beforeEnter: authGuard,
    component: StudioView,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?/ccetest/:id`,
    name: "ConstantCompositionExpansion",
    beforeEnter: authGuard,
    component: ConstantCompositionExpansionView,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?/separatortest/:id`,
    name: "MultiStageSeparatorTest",
    beforeEnter: authGuard,
    component: MultiStageSeparatorTestView,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?/viscositytest/:id`,
    name: "OilViscosity",
    beforeEnter: authGuard,
    component: OilViscosityView,
  },
  {
    path: `/:tenantPrefix/assets`,
    name: "Assets",
    beforeEnter: authGuard,
    redirect: (to) => `/${to.params.tenantPrefix}/data-management`,
  },
  {
    path: `/:tenantPrefix/assets/:asset`,
    name: "Fields",
    beforeEnter: authGuard,
    component: FieldsView,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field`,
    name: "Wells",
    beforeEnter: authGuard,
    component: WellsView,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?`,
    name: "Samples",
    beforeEnter: authGuard,
    component: SamplesView,
  },
  {
    path: `/:tenantPrefix/oilTest`,
    name: "OilTest",
    beforeEnter: authGuard,
    component: OilTestView,
  },
  {
    path: `/:tenantPrefix/gasTest`,
    name: "GasTest",
    beforeEnter: authGuard,
    component: GasTestView,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?/compositiontests/:id`,
    name: "Composition",
    beforeEnter: authGuard,
    component: CompositionView,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/samplevalidation/:sampleId`,
    name: "SampleValidation",
    beforeEnter: authGuard,
    component: SampleValidationView,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?/sampleinformation/:sampleId`,
    name: "SampleInformation",
    beforeEnter: authGuard,
    component: SampleInformationView,
  },
  {
    path: `/:tenantPrefix/assets/:asset/:field/:well/:sampleId?/cvdtest/:id`,
    name: "CvdTest",
    beforeEnter: authGuard,
    component: CvdTestView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling`,
    name: "AIMLModelling",
    beforeEnter: authGuard,
    component: AimlModellingView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs`,
    name: "DataInputs",
    beforeEnter: authGuard,
    component: DataInputsView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports`,
    name: "UploadReports",
    beforeEnter: authGuard,
    component: UploadReportsView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/select-from-database`,
    name: "SelectData",
    beforeEnter: authGuard,
    component: SelectDataView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/data-preview`,
    name: "DataPreview",
    beforeEnter: authGuard,
    component: DataPreviewView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/data-preview/ai-ml-models`,
    name: "AIMLModels",
    beforeEnter: authGuard,
    component: AimlModelsView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Supervisod-ml-models/support-vector-regression`,
    name: "SupervisedMLModels",
    beforeEnter: authGuard,
    component: SupervisedMlModelsView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Fluidsdata-ai-model`,
    name: "FluidsdataAIModel",
    beforeEnter: authGuard,
    component: FluidsdataAiModelView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Supervisod-ml-models/support-vector-regression/black-oil-table`,
    name: "BlackOilTable",
    beforeEnter: authGuard,
    component: BlackOilTableView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Supervisod-ml-models/support-vector-regression/selected-pvt-report`,
    name: "SelectedPVTReport",
    beforeEnter: authGuard,
    component: SelectedPvtReportView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Supervisod-ml-models/support-vector-regression/full-pvt-report`,
    name: "FullPVTReport",
    beforeEnter: authGuard,
    component: FullPvtReportView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Fluidsdata-ai-model/black-oil-table`,
    name: "FluidsdataBlackOilTable",
    beforeEnter: authGuard,
    component: BlackOilTableView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Fluidsdata-ai-model/selected-pvt-report`,
    name: "FluidsdataSelectedPVTReport",
    beforeEnter: authGuard,
    component: SelectedPvtReportView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/upload-reports/Fluidsdata-ai-model/full-pvt-report`,
    name: "FluidsdataFullPVTReport",
    beforeEnter: authGuard,
    component: FullPvtReportView,
  },
  {
    path: `/:tenantPrefix/ai-ml-modelling/define-inputs/manual-data-entry`,
    name: "ManualDataEntry",
    beforeEnter: authGuard,
    component: ManualDataEntryView,
  },
  {
    path: `/:tenantPrefix/data-management`,
    name: "DataManagement",
    beforeEnter: authGuard,
    component: DataManagementView,
  },
  {
    path: `/:tenantPrefix/fluidsIntelligence`,
    name: "fluidsdatapal",
    beforeEnter: authGuard,
    component: FluidsIntelligenceView,
  },
  {
    path: `/:tenantPrefix/pvt-prediction/:pvtPage+`,
    redirect: (to) => `/${to.params.tenantPrefix}/pvt-prediction`,
  },
  {
    path: `/:tenantPrefix/pvt-prediction`,
    name: "PVTPrediction",
    beforeEnter: authGuard,
    component: PvtPredictionView,
  },
  {
    path: `/:tenantPrefix/qaqc`,
    name: "QAQCIndex",
    beforeEnter: requireWriteQc,
    component: QaqcIndexView,
  },
  {
    path: `/:tenantPrefix/qaqc/overview`,
    name: "QAQCOverview",
    beforeEnter: requireWriteQc,
    component: QaqcOverviewView,
  },
  {
    path: `/:tenantPrefix/qaqc/detail/:well/sample/:sampleId/:fluidSampleID`,
    name: "QAQCDetailSample",
    beforeEnter: requireWriteQc,
    component: QaqcDetailView,
  },
  {
    path: `/:tenantPrefix/qaqc/detail/:well/report/:sampleId/:reportIdentifier`,
    name: "QAQCDetailReport",
    beforeEnter: requireWriteQc,
    component: QaqcDetailView,
  },
  {
    path: `/:tenantPrefix/qaqc/detail/:well?`,
    name: "QAQCDetailView",
    beforeEnter: requireWriteQc,
    component: QaqcDetailView,
  },
  {
    path: `/:tenantPrefix/qaqc/test/`,
    name: "QAQCTestRedirect",
    beforeEnter: requireWriteQc,
    redirect: (to) => ({
      path: `/${to.params.tenantPrefix}/qaqc/detail`,
      query: to.query,
    }),
  },
  {
    path: `/:tenantPrefix/qaqc/test/:sampleId/:testType/:testId`,
    name: "UnifiedTestView",
    beforeEnter: requireWriteQc,
    component: () => import("@/components/layout/QAQC/UnifiedTestView.vue"),
  },
  {
    path: `/:tenantPrefix/data-inventory-analysis`,
    name: "DataInventoryAnalysis",
    beforeEnter: authGuard,
    component: DataInventoryAnalysisView,
  },
  {
    path: `/:tenantPrefix/EDA/data-inventory-analysis/Compositon-chart`,
    name: "CompositionChart",
    beforeEnter: authGuard,
    component: CompositionChartView,
  },
  {
    path: `/:tenantPrefix/PVT-Properties`,
    name: "CorrelationAnalysis",
    beforeEnter: authGuard,
    component: CorrelationAnalysisView,
  },
  {
    path: `/:tenantPrefix/EDA/correlation-analysis/PVT-Properties/correlation-coefficient`,
    name: "CorrelationCoefficient",
    beforeEnter: authGuard,
    component: CorrelationCoefficientView,
  },
  {
    path: `/:tenantPrefix/Fluidsdata-insights`,
    name: "FluidsdataInsight",
    beforeEnter: authGuard,
    component: FluidsdataInsightView,
  },
  {
    path: `/:tenantPrefix/exploratory-data-analysis/:analysis`,
    name: "EDADashboard",
    beforeEnter: authGuard,
    component: EdaDashboardView,
  },
  {
    path: `/:tenantPrefix/Visualization-&-Dashboards`,
    name: "Main",
    beforeEnter: authGuard,
    component: DashboardMainView,
  },
  {
    path: `/:tenantPrefix/Visualization-&-Dashboards/:name`,
    name: "Board",
    beforeEnter: authGuard,
    component: DashboardBoardView,
  },
  {
    path: `/:tenantPrefix/Dashboards`,
    name: "DashboardList",
    beforeEnter: authGuard,
    component: DashboardListView,
  },
  {
    path: `/:tenantPrefix/Dashboards/view`,
    name: "DashboardView",
    beforeEnter: authGuard,
    component: DashboardViewView,
  },
  {
    path: `/:tenantPrefix/Dashboards/create`,
    name: "DashboardCreate",
    beforeEnter: authGuard,
    component: DashboardCreateView,
  },
  {
    path: `/:tenantPrefix/Dashboards/edit/:name`,
    name: "DashboardEdit",
    beforeEnter: authGuard,
    component: DashboardEditView,
  },
  {
    path: `/:tenantPrefix/users`,
    name: "UsersModule",
    beforeEnter: authGuard,
    component: UsersView,
  },
  {
    path: `/:tenantPrefix/roles`,
    name: "RolesModule",
    beforeEnter: authGuard,
    component: RolesView,
  },
  {
    path: `/:tenantPrefix/agentic-dashboard`,
    name: "AgenticDashboard",
    beforeEnter: authGuard,
    component: AgenticDashboardView,
  },
  {
    path: `/:tenantPrefix/agentic-dashboard/all`,
    name: "AgenticDashboardAll",
    beforeEnter: authGuard,
    component: AgenticDashboardView,
  },
  {
    path: `/:tenantPrefix/agentic-dashboard/starred`,
    name: "AgenticDashboardStarred",
    beforeEnter: authGuard,
    component: AgenticDashboardView,
  },
  {
    path: `/:tenantPrefix/agentic-dashboard/shared`,
    name: "AgenticDashboardShared",
    beforeEnter: authGuard,
    component: AgenticDashboardView,
  },
  {
    path: `/:tenantPrefix/agentic-dashboard/:dashboardName`,
    name: "AgenticDashboardView",
    beforeEnter: authGuard,
    component: AgenticDashboardView,
  },
  {
    path: `/:tenantPrefix/:catchAll(.*)`,
    name: "NotFound",
    component: () => import("@/views/NotFound/NotFound.vue"),
  },
];
